import { setTitleCredits } from 'components/app/editor/_mediator/editor-controls.slice';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';

import { Modal } from 'components/UI/modal/modal';
import { __TitleCreditsModal } from './_title-credits-modal';
import styles from './_title-credits.module.scss';

export const TitleCreditsModal = () => {
  const titleCredits = useAppSelector((state) => state.editor__controls.titleCredits);
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(setTitleCredits(null));
  };

  return (
    <Modal className={styles.TitleCredits} onRequestClose={onClose} isOpen={titleCredits !== null}>
      {titleCredits && (
        <__TitleCreditsModal config={titleCredits.data} isTitle={titleCredits?.key === 'title'} onClose={onClose} />
      )}
    </Modal>
  );
};
